module.exports = __webpack_public_path__ + "img/agency_img_4.4a2dc2fc.png";